import { render } from "./AutoTopupActivationMPayLandingCancel.vue?vue&type=template&id=cfb6a64a&scoped=true"
import script from "./AutoTopupActivationMPayLandingCancel.vue?vue&type=script&lang=js"
export * from "./AutoTopupActivationMPayLandingCancel.vue?vue&type=script&lang=js"

import "./AutoTopupActivationMPayLandingCancel.vue?vue&type=style&index=0&id=cfb6a64a&scoped=true&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb6a64a"]])

export default __exports__